import bg from '../assets/bg.webp'
import bgmob from '../assets/bgmob.webp'
import star from '../assets/star.svg'
import og from '../assets/avatars/og.webp'
import coder from '../assets/avatars/coder.webp'
import traveller from '../assets/avatars/traveller.webp'
import ceo from '../assets/avatars/ceo.webp'
import artist from '../assets/avatars/artist.webp'
import singer from '../assets/avatars/singer.webp'
import info from '../assets/info.svg'
import {motion} from "framer-motion";

const Header = () => {
    return(
        <div>
            <header className='flex flex-col justify-center items-center'>
                <div className="flex relative bg-white justify-center items-center flex-col z-100 h-[15rem] overflow-hidden">
                    <motion.p 
                        drag
                        dragElastic={0.3}
                        dragConstraints={{
                        top: -10,
                        left: -10,
                        right: 10,
                        bottom: 10,
                        }}
                        className="cursor-move absolute text-5xl handwr text-center toppp font-semibold"><abbr title="Have fun with my Name (◔◡◔)">Hari Prasad</abbr>
                    </motion.p>

                    <div className='toppp '>

                    <section id='slideshow' className='flex'>
                       
                        <img className='pc absolute w-[22rem] left-0 -bottom-[0.2rem] toppp ' src={og} alt="hari prasad designer"/>
                        <img className='pc absolute w-[22rem] left-0 -bottom-[0.2rem] toppp' src={coder} alt="hari prasad designer"/>                        
                        <img className='pc absolute w-[22rem] left-0 -bottom-[0.2rem] toppp' src={traveller} alt="hari prasad designer"/>
                        <img className='pc absolute w-[22rem] left-0 -bottom-[0.2rem] toppp' src={ceo} alt="hari prasad designer"/>
                        <img className='pc absolute w-[22rem] left-0 -bottom-[0.2rem] toppp' src={artist} alt="hari prasad designer"/>
                        <img className='pc absolute w-[22rem] left-0 -bottom-[0.2rem] toppp' src={singer} alt="hari prasad designer"/>
                
                    </section>

                    <section id='slideshow' className='toppp pc'>
                        <p className='bottom-5 flex flex-row gap-2 drop-shadow-2xl text-md md: bg-white rounded-full w-fit py-4 px-7 right-[2rem] bottom-5 '><img src={info} alt=""/>OG Hari Prasad</p>  
                        <p className='bottom-5 flex flex-row gap-2 drop-shadow-2xl text-md md: bg-white rounded-full w-fit py-4 px-7 right-[2rem] bottom-5 '><img src={info} alt=""/>Hari Prasad, The Geek 👨‍💻</p>  
                        <p className='bottom-5 flex flex-row gap-2 drop-shadow-2xl text-md md: bg-white rounded-full w-fit py-4 px-7 right-[2rem] bottom-5 '><img src={info} alt=""/>🧳 Travel lover</p>  
                        <p className='bottom-5 flex flex-row gap-2 drop-shadow-2xl text-md md: bg-white rounded-full w-fit py-4 px-7 right-[2rem] bottom-5 '><img src={info} alt=""/>CEO 😎</p>  
                        <p className='bottom-5 flex flex-row gap-2 drop-shadow-2xl text-md md: bg-white rounded-full w-fit py-4 px-7 right-[2rem] bottom-5 '><img src={info} alt=""/>Artist 🧑‍🎨 by soul</p>  
                        <p className='bottom-5 flex flex-row gap-2 drop-shadow-2xl text-md md: bg-white rounded-full w-fit py-4 px-7 right-[2rem] bottom-5 '><img src={info} alt=""/>Bathroom Singer 🧑‍🎤</p>                
                    </section>
                    </div>

                    <img className="pc blur-[0.5px] w-auto" src={bg} rel="preload" alt='bg' />
                    <img className=" w-auto mob" src={bgmob} rel="preload" alt='bg' />
                </div>
                <motion.a
                    className='relative scaleup toppp -top-[4rem] w-[8rem]' target="_blank" rel="noreferrer" href='https://devignx.hariprasd.me/'><img src={star} alt='STAR'></img>
                </motion.a>
            </header>
        </div>
    )
}


export default Header;